/**
 * Socket 'imzaMessage' olayının yükünü SweetAlert2'ye vermeden önce süzer (DEV-3900).
 *
 * Olay kabuk üzerinden gelir ve gövdesini bu uygulamanın kontrol etmediği bir kaynak
 * (başka bir yerel süreç, eski kabuk) üretebilir; ham yükü `Swal.fire`a vermek HTML
 * enjeksiyonuna (html, footer, iconHtml, didOpen...) kapı açar. Burada yalnız KANONİK
 * alan listesi geçer: title, text, icon, allowOutsideClick, confirmButtonColor,
 * confirmButtonText. Kaçışlamanın sahibi TÜKETİCİDİR (kabuk metni değiştirmez; eski
 * kabuklar ham metin geçirir): title -> titleText (SweetAlert2 11'de `title` HTML olarak
 * ayrıştırılır, `titleText` düz metindir), text düz metindir, confirmButtonText
 * HTML-kaçışlanır. Geçersiz icon/renk düşer; title ve text yoksa pencere gösterilmez.
 * icrapro-app aynı kuralı uygular.
 *
 * Saf tutuldu (store/DOM bağımlılığı yok) ki birim testten geçebilsin.
 */

export interface TemizImzaMesaji {
    titleText?: string;
    text?: string;
    icon?: 'success' | 'error' | 'warning' | 'info' | 'question';
    allowOutsideClick?: boolean;
    confirmButtonColor?: string;
    confirmButtonText?: string;
}

const SINIR_BASLIK = 200;
const SINIR_METIN = 1000;
const SINIR_DUGME = 60;

const KACIS: {[karakter: string]: string} = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};

function htmlKacisla(metin: string): string {
    return metin.replace(/[&<>"']/g, (k) => KACIS[k]);
}

function doluMetin(deger: unknown, sinir: number): string | null {
    if (typeof deger !== 'string') {
        return null;
    }
    const kirpik = deger.trim();
    return kirpik === '' ? null : kirpik.slice(0, sinir);
}

export function imzaMesajiniTemizle(ham: unknown): TemizImzaMesaji | null {
    if (!ham || typeof ham !== 'object' || Array.isArray(ham)) {
        return null;
    }
    const g = ham as {
        title?: unknown, text?: unknown, icon?: unknown, allowOutsideClick?: unknown,
        confirmButtonColor?: unknown, confirmButtonText?: unknown
    };
    const temiz: TemizImzaMesaji = {};

    const baslik = doluMetin(g.title, SINIR_BASLIK);
    if (baslik !== null) {
        temiz.titleText = baslik;
    }
    const metin = doluMetin(g.text, SINIR_METIN);
    if (metin !== null) {
        temiz.text = metin;
    }
    // Başlık da metin de yoksa gösterilecek bir şey yok.
    if (temiz.titleText === undefined && temiz.text === undefined) {
        return null;
    }

    if (g.icon === 'success' || g.icon === 'error' || g.icon === 'warning' ||
        g.icon === 'info' || g.icon === 'question') {
        temiz.icon = g.icon;
    }
    if (typeof g.allowOutsideClick === 'boolean') {
        temiz.allowOutsideClick = g.allowOutsideClick;
    }
    if (typeof g.confirmButtonColor === 'string' && /^#[0-9a-fA-F]{3,8}$/.test(g.confirmButtonColor)) {
        temiz.confirmButtonColor = g.confirmButtonColor;
    }
    const dugme = doluMetin(g.confirmButtonText, SINIR_DUGME);
    if (dugme !== null) {
        temiz.confirmButtonText = htmlKacisla(dugme);
    }
    return temiz;
}
